const features = [
  {
    icon: 'ri-smartphone-line',
    title: '多端适配',
    description: '全面支持桌面端和移动端，随时随地畅享成91平台的优质服务体验，界面自适应显示。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全可靠',
    description: '采用业界领先的数据加密技术，端到端保护用户信息安全，让您安心使用平台所有功能。',
  },
  {
    icon: 'ri-brain-line',
    title: '智能推荐',
    description: '基于先进的AI算法，精准分析您的使用偏好，为您推送最感兴趣的优质内容和功能。',
  },
  {
    icon: 'ri-user-heart-line',
    title: '用户至上',
    description: '坚持以用户为中心的设计理念，7x24小时全天候客服支持，用心倾听每一位用户的声音。',
  },
  {
    icon: 'ri-bar-chart-box-line',
    title: '数据分析',
    description: '提供全面的数据洞察工具，帮助您深入了解内容表现和用户行为，驱动数据化决策。',
  },
  {
    icon: 'ri-group-line',
    title: '社区互动',
    description: '活跃的用户社区，丰富的互动方式，让您在成91平台上结识志同道合的朋友。',
  },
];

export default function FeaturesSection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            核心功能
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            成91为您提供全方位的平台服务与功能支持，每一项功能都经过精心设计
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((feature, idx) => (
            <div
              key={idx}
              className="group p-6 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-primary-100 rounded-lg mb-4 group-hover:bg-primary-200 transition-colors">
                <i className={`${feature.icon} text-xl text-primary-600`}></i>
              </div>
              <h3 className="font-heading font-semibold text-foreground-950 mb-2">{feature.title}</h3>
              <p className="text-foreground-600 text-sm leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}